<div class="row" *ngIf="data">
  <!-- Average Health Score -->
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-warning card-header-icon">
        <div class="card-icon">
          <i class="material-icons">speed</i>
        </div>
        <p class="card-category">Avg Health Score</p>
        <h3 class="card-title" [ngClass]="healthClass">{{ data.avgScore }}</h3>
      </div>
      <div class="card-footer">
        <div class="stats">
          <i class="material-icons text-info">info</i>
          Global technical status
        </div>
      </div>
    </div>
  </div>

  <!-- Healthy Pages -->
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-success card-header-icon">
        <div class="card-icon">
          <i class="material-icons">check_circle</i>
        </div>
        <p class="card-category">Healthy Pages</p>
        <h3 class="card-title text-success">{{ data.healthy }}</h3>
      </div>
      <div class="card-footer">
        <div class="stats">
          <i class="material-icons">update</i> Just updated
        </div>
      </div>
    </div>
  </div>

  <!-- Warnings -->
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-info card-header-icon">
        <div class="card-icon">
          <i class="material-icons">warning</i>
        </div>
        <p class="card-category">Warnings</p>
        <h3 class="card-title text-warning">{{ data.warning }}</h3>
      </div>
      <div class="card-footer">
        <div class="stats">
          <i class="material-icons">priority_high</i> Needs attention
        </div>
      </div>
    </div>
  </div>

  <!-- Critical Issues -->
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-danger card-header-icon">
        <div class="card-icon">
          <i class="material-icons">report_problem</i>
        </div>
        <p class="card-category">Critical Issues</p>
        <h3 class="card-title text-danger">{{ data.critical }}</h3>
      </div>
      <div class="card-footer">
        <div class="stats">
          <i class="material-icons">error</i> Fix immediately
        </div>
      </div>
    </div>
  </div>
</div>
